export default __webpack_public_path__ + "static/media/element_39.ab96355e.avif";